import React from "react";

const RIghtAlign = ({ width = 14, height = 14, selected }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 14"
      fill={selected ? "#0072C6" : "white"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 0H17V14H16V0Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 5H15V9H12V5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 5H11V9H8V5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 5H7V9H4V5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 5H3V9H0V5Z"
        fill={selected ? "white" : "black"}
      />
    </svg>
  );
};

export default RIghtAlign;
